import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSupplier, getSupplierHistory, getSupplierItems } from "api/suppliers";
import { SupplierModal } from "components/suppliers/SupplierModal";
import QRCode from "qrcode";

// Icons
const Icons = {
    Building: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
            <path d="M9 22v-4h6v4" />
            <path d="M8 6h.01" />
            <path d="M16 6h.01" />
            <path d="M8 10h.01" />
            <path d="M16 10h.01" />
            <path d="M8 14h.01" />
            <path d="M16 14h.01" />
            <path d="M8 18h.01" />
            <path d="M16 18h.01" />
        </svg>
    ),
    Phone: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
    ),
    Mail: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect width="20" height="16" x="2" y="4" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
    ),
    MapPin: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
    FileText: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="9" y1="15" x2="15" y2="15" />
            <line x1="9" y1="11" x2="15" y2="11" />
        </svg>
    ),
    Edit: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Back: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="m15 18-6-6 6-6" />
        </svg>
    ),
    Box: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
            <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
            <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
    ),
    DollarSign: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
    ),
    Activity: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
    ),
    Download: (p) => (
        <svg {...p} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
};

const formatMoney = (amount) => {
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'UZS',
        maximumFractionDigits: 0
    }).format(amount || 0);
};

const downloadHistory = (acts, supplierName) => {
    if (!acts || acts.length === 0) {
        alert('Нет данных для скачивания');
        return;
    }

    // CSV Headers
    const headers = ['Дата', '№ Акта', 'Товар', 'Ед.изм', 'Кол-во', 'Цена', 'Сумма'];
    const rows = [];

    acts.forEach(act => {
        const date = new Date(act.created_at).toLocaleDateString('ru-RU');
        const actNo = act.act_no || act.id;

        if (act.positions && act.positions.length > 0) {
            act.positions.forEach(pos => {
                const qty = Number(pos.qty) || 0;
                const price = Number(pos.price) || 0;
                const total = qty * price;

                rows.push([
                    date,
                    actNo,
                    pos.item_name || '-',
                    pos.item_unit || '-',
                    qty,
                    price,
                    total
                ]);
            });
        } else {
            // Fallback if no positions detailed
            rows.push([date, actNo, 'Акт без позиций', '-', '0', '0', '0']);
        }
    });

    const csvContent = [
        headers.join(','),
        ...rows.map(r => r.map(c => `"${c}"`).join(','))
    ].join('\n');

    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `history_${supplierName || 'supplier'}_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
};

export default function SupplierProfile() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [supplier, setSupplier] = useState(null);
    const [history, setHistory] = useState([]);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [qrCode, setQrCode] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [historyFilters, setHistoryFilters] = useState({
        dateFrom: '',
        dateTo: ''
    });

    const fetchData = React.useCallback(async () => {
        if (!id) return;
        try {
            if (!supplier) setLoading(true);

            const supplierData = await getSupplier(id);
            setSupplier(supplierData);

            // Товары поставщика
            try {
                const itemsData = await getSupplierItems(id);
                setItems(Array.isArray(itemsData) ? itemsData : (itemsData.results || []));
            } catch (itemsError) {
                console.error("Failed to load supplier items:", itemsError);
                setItems([]);
            }

            const qr = await QRCode.toDataURL(`SUPPLIER:${id}`, {
                width: 256,
                margin: 2,
                color: { dark: '#000000', light: '#ffffff' }
            });
            setQrCode(qr);

            try {
                const params = {};
                if (historyFilters.dateFrom) params.date_from = historyFilters.dateFrom;
                if (historyFilters.dateTo) params.date_to = historyFilters.dateTo;

                const historyData = await getSupplierHistory(id, params);
                const acts = Array.isArray(historyData) ? historyData : (historyData.results || []);
                setHistory(acts);
            } catch (histError) {
                console.error("Failed to load supplier history:", histError);
                setHistory([]);
            }
        } catch (error) {
            console.error("Failed to load supplier:", error);
        } finally {
            setLoading(false);
        }
    }, [id, historyFilters]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const stats = useMemo(() => {
        const totalActs = history.length;

        // Сумма закупок по актам
        let totalValue = 0;
        history.forEach((act) => {
            if (act.positions && Array.isArray(act.positions)) {
                act.positions.forEach((pos) => {
                    const qty = Number(pos.qty) || 0;
                    const price = Number(pos.price) || 0;
                    totalValue += qty * price;
                });
            }
        });

        // Количество «назначенных» товаров поставщику (по связке item.supplier)
        const totalItems = items.length;

        return { totalActs, totalItems, totalValue };
    }, [history, items]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-slate-900">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!supplier) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-slate-900 p-4">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-slate-100">Поставщик не найден</h2>
                <button
                    onClick={() => navigate("/suppliers")}
                    className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                >
                    Вернуться к списку
                </button>
            </div>
        );
    }



    return (
        <div className="min-h-screen bg-gray-50/50 dark:bg-slate-900 transition-colors pb-12">
            {/* Hero Section */}
            <div className="relative bg-gradient-to-br from-blue-700 to-indigo-800 pb-24 pt-8 px-4 sm:px-6 lg:px-8 shadow-lg overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-10" style={{
                    backgroundImage: "radial-gradient(rgba(255, 255, 255, 0.5) 1px, transparent 1px)",
                    backgroundSize: "24px 24px"
                }}></div>

                <div className="max-w-6xl mx-auto relative z-10">
                    <button
                        onClick={() => navigate("/suppliers")}
                        className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors mb-6 text-sm font-medium"
                    >
                        <Icons.Back className="w-4 h-4" />
                        Назад к списку
                    </button>

                    <div className="flex flex-col md:flex-row items-start justify-between gap-6">
                        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 text-center md:text-left">
                            <div className="h-24 w-24 bg-white/10 backdrop-blur-md rounded-2xl flex items-center justify-center border border-white/20 shadow-xl">
                                <Icons.Building className="w-12 h-12 text-white" />
                            </div>
                            <div>
                                <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight leading-tight">
                                    {supplier.name}
                                </h1>
                                <div className="mt-2 flex flex-wrap items-center justify-center md:justify-start gap-3 text-blue-100">
                                    <span className="bg-white/10 px-2 py-0.5 rounded text-xs font-mono border border-white/10 backdrop-blur-sm">
                                        ID: {supplier.id}
                                    </span>
                                    <span className="hidden sm:inline-block h-1 w-1 rounded-full bg-white/40"></span>
                                    <span className="text-sm">Поставщик</span>
                                </div>
                                <div className="mt-6 flex gap-3 justify-center md:justify-start">
                                    <button
                                        onClick={() => setShowModal(true)}
                                        className="px-4 py-2 bg-white text-blue-700 rounded-lg text-sm font-semibold hover:bg-blue-50 transition shadow-sm flex items-center gap-2"
                                    >
                                        <Icons.Edit className="w-4 h-4" />
                                        Редактировать
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* QR Code Card */}
                        <div className="bg-white p-3 rounded-xl shadow-xl transform rotate-2 hover:rotate-0 transition-transform duration-300">
                            {qrCode && (
                                <img src={qrCode} alt="QR Code" className="w-32 h-32 block" />
                            )}
                            <p className="text-[10px] text-center text-gray-400 mt-1 uppercase tracking-wider font-semibold">
                                Scan Me
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16 relative z-20 space-y-8">
                {/* Stats Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100 dark:border-slate-700 flex items-start justify-between group">
                        <div>
                            <p className="text-sm font-medium text-gray-500 dark:text-slate-400 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">Всего поставок</p>
                            <h3 className="text-2xl font-bold text-gray-900 dark:text-slate-100 mt-1">{stats.totalActs}</h3>
                        </div>
                        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 rounded-xl group-hover:scale-110 transition-transform">
                            <Icons.Activity className="w-6 h-6" />
                        </div>
                    </div>
                    <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100 dark:border-slate-700 flex items-start justify-between group">
                        <div>
                            <p className="text-sm font-medium text-gray-500 dark:text-slate-400 group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors">Сумма закупок</p>
                            <h3 className="text-2xl font-bold text-gray-900 dark:text-slate-100 mt-1">
                                {new Intl.NumberFormat('ru-RU', { notation: "compact", maximumFractionDigits: 1 }).format(stats.totalValue)}
                                <span className="text-sm text-gray-400 font-normal ml-1">сум</span>
                            </h3>
                        </div>
                        <div className="p-3 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 rounded-xl group-hover:scale-110 transition-transform">
                            <Icons.DollarSign className="w-6 h-6" />
                        </div>
                    </div>
                    <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-gray-100 dark:border-slate-700 flex items-start justify-between group">
                        <div>
                            <p className="text-sm font-medium text-gray-500 dark:text-slate-400 group-hover:text-violet-600 dark:group-hover:text-violet-400 transition-colors">Всего товаров</p>
                            <h3 className="text-2xl font-bold text-gray-900 dark:text-slate-100 mt-1">
                                {stats.totalItems}
                            </h3>
                            <p className="mt-1 text-xs text-gray-400 dark:text-slate-500">
                                По полю поставщика в карточке товара
                            </p>
                        </div>
                        <div className="p-3 bg-violet-50 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400 rounded-xl group-hover:scale-110 transition-transform">
                            <Icons.Box className="w-6 h-6" />
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    {/* Left Col: Contact Info + Items */}
                    <div className="lg:col-span-1 space-y-6">
                        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-gray-100 dark:border-slate-700 overflow-hidden">
                            <div className="px-6 py-4 border-b border-gray-100 dark:border-slate-700 bg-gray-50/50 dark:bg-slate-800/50">
                                <h3 className="font-semibold text-gray-900 dark:text-slate-100">Контакты</h3>
                            </div>
                            <div className="p-6 space-y-4">
                                <div className="flex items-start gap-4">
                                    <div className="p-2 bg-gray-100 dark:bg-slate-700 rounded-lg text-gray-500 dark:text-slate-400 shrink-0">
                                        <Icons.Phone className="w-5 h-5" />
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-xs text-gray-500 dark:text-slate-400 uppercase font-medium">Телефон</p>
                                        <a href={`tel:${supplier.phone}`} className="text-sm font-medium text-gray-900 dark:text-slate-100 hover:text-blue-600 truncate block mt-0.5">
                                            {supplier.phone || "Не указан"}
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-start gap-4">
                                    <div className="p-2 bg-gray-100 dark:bg-slate-700 rounded-lg text-gray-500 dark:text-slate-400 shrink-0">
                                        <Icons.Mail className="w-5 h-5" />
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-xs text-gray-500 dark:text-slate-400 uppercase font-medium">Email</p>
                                        <a href={`mailto:${supplier.email}`} className="text-sm font-medium text-gray-900 dark:text-slate-100 hover:text-blue-600 truncate block mt-0.5">
                                            {supplier.email || "Не указан"}
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-start gap-4">
                                    <div className="p-2 bg-gray-100 dark:bg-slate-700 rounded-lg text-gray-500 dark:text-slate-400 shrink-0">
                                        <Icons.MapPin className="w-5 h-5" />
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-xs text-gray-500 dark:text-slate-400 uppercase font-medium">Адрес</p>
                                        <p className="text-sm font-medium text-gray-900 dark:text-slate-100 mt-0.5">
                                            {supplier.address || "Не указан"}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Supplier Items */}
                        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-gray-100 dark:border-slate-700 overflow-hidden">
                            <div className="px-6 py-4 border-b border-gray-100 dark:border-slate-700 bg-gray-50/50 dark:bg-slate-800/50 flex items-center justify-between">
                                <h3 className="font-semibold text-gray-900 dark:text-slate-100">Товары поставщика</h3>
                                <span className="bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300 text-xs font-medium px-2.5 py-0.5 rounded-full">
                                    {items.length} шт.
                                </span>
                            </div>
                            {items.length > 0 ? (
                                <div className="max-h-80 overflow-auto">
                                    <table className="w-full text-sm text-left">
                                        <thead className="text-xs text-gray-500 dark:text-slate-400 uppercase bg-gray-50 dark:bg-slate-700/50">
                                            <tr>
                                                <th className="px-4 py-2 font-medium">Наименование</th>
                                                <th className="px-4 py-2 font-medium">Артикул</th>
                                                <th className="px-4 py-2 font-medium text-right">Остаток</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-100 dark:divide-slate-700">
                                            {items.map((item) => (
                                                <tr key={item.id} className="bg-white dark:bg-slate-800">
                                                    <td className="px-4 py-2 text-gray-900 dark:text-slate-100">
                                                        {item.name}
                                                    </td>
                                                    <td className="px-4 py-2 text-gray-500 dark:text-slate-400">
                                                        {item.sku || "—"}
                                                    </td>
                                                    <td className="px-4 py-2 text-right text-gray-900 dark:text-slate-100">
                                                        {Number(item.qty_on_hand ?? 0)} {item.unit}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="p-6 text-sm text-gray-500 dark:text-slate-400">
                                    У этого поставщика пока нет назначенных товаров.
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right Col: History */}
                    <div className="lg:col-span-2">
                        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-gray-100 dark:border-slate-700 overflow-hidden">
                            <div className="px-6 py-4 border-b border-gray-100 dark:border-slate-700 flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-gray-50/50 dark:bg-slate-800/50">
                                <div className="flex items-center gap-3">
                                    <h3 className="font-semibold text-gray-900 dark:text-slate-100">История поставок</h3>
                                    <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-xs font-medium px-2.5 py-0.5 rounded-full">
                                        {stats.totalActs}
                                    </span>
                                </div>

                                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
                                    <div className="flex items-center gap-2 w-full sm:w-auto">
                                        <input
                                            type="date"
                                            value={historyFilters.dateFrom}
                                            onChange={(e) => setHistoryFilters({ ...historyFilters, dateFrom: e.target.value })}
                                            className="w-full sm:w-auto text-xs px-3 py-2 border border-gray-200 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-shadow"
                                            placeholder="От"
                                        />
                                        <span className="text-gray-400 shrink-0">-</span>
                                        <input
                                            type="date"
                                            value={historyFilters.dateTo}
                                            onChange={(e) => setHistoryFilters({ ...historyFilters, dateTo: e.target.value })}
                                            className="w-full sm:w-auto text-xs px-3 py-2 border border-gray-200 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-shadow"
                                            placeholder="До"
                                        />
                                    </div>

                                    <div className="h-6 w-px bg-gray-200 dark:bg-slate-600 mx-1 hidden sm:block"></div>

                                    <button
                                        onClick={() => downloadHistory(history, supplier.name)}
                                        className="w-full sm:w-auto justify-center text-xs font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 flex items-center gap-2 active:scale-95 transition-all bg-blue-50 hover:bg-blue-100 dark:bg-blue-900/20 dark:hover:bg-blue-900/40 px-4 py-2 rounded-lg"
                                        title="Скачать историю в CSV"
                                    >
                                        <Icons.Download className="w-3.5 h-3.5" />
                                        Скачать
                                    </button>
                                </div>
                            </div>

                            {history.length > 0 ? (
                                <div className="overflow-x-auto w-full">
                                    <table className="w-full text-sm text-left min-w-[300px] sm:min-w-[500px] md:min-w-full">
                                        <thead className="text-xs text-gray-500 dark:text-slate-400 uppercase bg-gray-50 dark:bg-slate-700/50">
                                            <tr>
                                                <th className="px-6 py-3 font-medium">Акт №</th>
                                                <th className="px-6 py-3 font-medium">Дата</th>
                                                <th className="px-6 py-3 font-medium text-right">Позиций</th>
                                                <th className="px-6 py-3 font-medium text-right">Сумма</th>
                                                <th className="px-6 py-3 font-medium text-center">Статус</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-100 dark:divide-slate-700">
                                            {history.map((act) => {
                                                const actItems = act.positions?.length || 0;
                                                const actTotal = act.positions?.reduce((sum, p) => sum + (Number(p.qty) * Number(p.price)), 0) || 0;
                                                return (
                                                    <tr key={act.id} className="bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors">
                                                        <td className="px-6 py-4 font-medium text-gray-900 dark:text-slate-100">
                                                            {act.act_no || `#${act.id}`}
                                                        </td>
                                                        <td className="px-6 py-4 text-gray-500 dark:text-slate-400 whitespace-nowrap">
                                                            {new Date(act.created_at).toLocaleDateString('ru-RU')}
                                                        </td>
                                                        <td className="px-6 py-4 text-right text-gray-900 dark:text-slate-100">
                                                            {actItems}
                                                        </td>
                                                        <td className="px-6 py-4 text-right font-medium text-gray-900 dark:text-slate-100">
                                                            {formatMoney(actTotal)}
                                                        </td>
                                                        <td className="px-6 py-4 text-center">
                                                            <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400">
                                                                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                                                                Принят
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="p-8 text-center text-gray-500 dark:text-slate-400">
                                    <Icons.FileText className="w-12 h-12 mx-auto text-gray-300 dark:text-slate-600 mb-3" />
                                    <p>История поставок пуста</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <SupplierModal
                    supplier={supplier}
                    onClose={() => setShowModal(false)}
                    onSaved={() => {
                        setShowModal(false);
                        fetchData();
                    }}
                />
            )}
        </div>
    );
}

